// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1g664","buttons":"RemoveExpirationActionButtons_buttons__z9A8Z"};